import React from "react";

interface ComingSoonProps {
    description: string;
}

const ComingSoon = ({ description }: ComingSoonProps) => {
    return (
        <div className="flex flex-col items-center justify-center gap-2 -mt-4 text-gray-500">
            <h2 className="text-xl md:text-2xl font-semibold">Coming Soon</h2>
            <p className="max-w-md px-6">
                {description}
            </p>
        </div>
    );
};

export default ComingSoon;
